import React from "react";
import { useSelector } from "react-redux";
import { selectModalState, ModalTypes } from "reducers/globalModal";
import { UploadDocumentModalBusinessForm } from "./UploadDocumentModalBusinessForm";

export const GlobalModal = () => {
  const modalState = useSelector(selectModalState);
  if (modalState.modalType === ModalTypes.UPLOAD_BUSINESS_DOCUMENT)
    return <UploadDocumentModalBusinessForm />;
  return null;
};
